import { Component, ElementRef, HostListener, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { UserService } from 'src/app/user.service';
import { BehaviorSubject, Observable, take } from "rxjs";
import { Router } from '@angular/router';
//import { Console } from 'console';

@Component({

  selector: 'sdc-app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeaderComponent {
  userName: string;
  role: string;
  clicked: boolean;
  isExpanded: boolean;
  accountInfo$: Observable<any>;
  user: Observable<any>;

  // public currentUser: BehaviorSubject<any> = new BehaviorSubject(null);

  @HostListener('document:click', ['event'])
  clickedOutside(): void {
    if (this.clicked) {
      this.isExpanded = false;
    }
  }

  constructor(
    private dialog: MatDialog,
    private userService: UserService,
    private router: Router
  ) {
  }

  ngOnInit(){
    this.userName = JSON.parse(localStorage.getItem('currentUser')).userName;
    this.role = JSON.parse(localStorage.getItem('currentUser')).role;
  }

  onClick(event): void {
    event.preventDefault();
    event.stopPropagation();
    this.clicked = true;
  }

  logout(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data:
      {
        title: 'Logout & Exit the Application?',
        message: 'Are you sure you want to logout?'
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.userService.removeToken();
        localStorage.removeItem('currentUser');
        this.router.navigateByUrl('login');
      }
    });
  }
}
